import { FC, useEffect, useState } from "react";
import { useDriverStore } from "../../../hooks/useDriverStore";
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { ApiStatus } from "../../../types/api/status";
import { RoutesMap } from "../../../types";
import { DriverFormDrawer } from "../DriverFormDrawer/DriverFormDrawer";
import { driver } from "../../../types/slices/driverType";
import { ModalConfirm } from "../../../components/common/ModalConfirm/ModalConfirm";
import { maskRUT } from "../../../toolbox/helpers/rut-helper";

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align: 'center' },
    {
        type: 'text', field: 'name', label: 'RUT', align: 'center',
        format: (row) => maskRUT(row.rut)
    },
    { type: 'text', field: 'name', label: 'Nombre', align: 'center' },
]

const breadcrumbs = [
    { id: 1, label: 'Maestros' },
    { id: 2, label: 'Conductores', pathname: RoutesMap.DRIVER_LIST }
]

export const DriverList: FC = () => {
    const { status: statusDriver, drivers, totalRows, driverSelected,
        getDrivers, setSelectedDriver, deleteDriver } = useDriverStore()

    const [search, setSearch] = useState<string>('')
    const [page, setPage] = useState<number>(1)
    const [perPage, setPerPage] = useState<number>(10)

    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false)
    const [showForm, setShowForm] = useState<boolean>(false)

    useEffect(() => {
        if (search === '') {
            getDataAPI()
        } else {
            const timer = setTimeout(() => getDataAPI(), 500)
            return () => clearTimeout(timer)
        }
    }, [page, perPage, search])

    const getDataAPI = async (): Promise<void> => {
        await getDrivers({
            page: page,
            perPage: perPage,
            search: search !== '' ? search : undefined
        })
    }

    const onSearch = (value: string): void => {
        setSearch(value)
        setPage(1)
    }

    const handleChangePage = (event: any, newPage: any) => {
        setPage(newPage + 1)
    }

    const handleChangeRowsPerPage = (event) => {
        setPerPage(+event.target.value)
        setPage(1)
    }

    const onAdd = (): void => {
        setSelectedDriver({} as driver)
        setShowForm(true)
    }

    const onEdit = (rowSelected: driver): void => {
        setSelectedDriver(rowSelected)
        setShowForm(true)
    }

    const onDelete = (rowSelected) => {
        setSelectedDriver(rowSelected)
        setShowModalConfirm(true)
    }

    const onDeleteConfirm = async (): Promise<void> => {
        const resp = await deleteDriver(driverSelected?.id)
        if (resp === true) {
            setShowModalConfirm(false)
            getDataAPI()
        }
    }

    return (<>
        <CustomTable
            title="Lista de conductores"
            breadcrumbs={breadcrumbs}
            columns={columns}
            loading={statusDriver === ApiStatus.FETCHING}
            rows={drivers || []}
            onRowClick={() => { }}
            hasOptions
            dense
            onSearch={onSearch}
            onAddFn={onAdd}
            onEdit={onEdit}
            onDelete={onDelete}

            totalRows={totalRows}
            rowsPerPage={perPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            withCustomPagination={true}
        />
        {showForm && (
            <DriverFormDrawer
                open={showForm}
                onClose={() => setShowForm(false)}
                onList={getDataAPI}
            />
        )}
        {showModalConfirm && (
            <ModalConfirm
                open={showModalConfirm}
                closeModal={() => { setShowModalConfirm(false) }}
                onConfirm={onDeleteConfirm}
                status={statusDriver === ApiStatus.FETCHING}
            />
        )}
    </>)
}